export type DialogBtnProps = {
  onClick: () => void;
};

export enum TestID {
  AddButton = 'add_cost_center_btn',
  AddButtonCTA = 'add_cost_center_cta'
}
